"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _list = require("./list.style");
var _list2 = require("./list.util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
const List = _ref => {
  let {
    className = 'list',
    listData,
    noBorder = false,
    onSelect
  } = _ref;
  const [active, setActive] = (0, _react.useState)({
    group: -1,
    list: -1
  });
  const [listDataState, setListDataState] = (0, _react.useState)(listData);
  const onSelectedActive = (index, subIndex) => {
    var _a, _b, _c, _d;
    setActive({
      group: index,
      list: subIndex
    });
    const currentListData = (0, _list2.activateClickedItem)(listData, index, subIndex);
    setListDataState(currentListData);
    const selectedItem = {
      group: (_a = currentListData === null || currentListData === void 0 ? void 0 : currentListData[index]) === null || _a === void 0 ? void 0 : _a.group,
      items: (_b = currentListData === null || currentListData === void 0 ? void 0 : currentListData[index]) === null || _b === void 0 ? void 0 : _b.items.filter(m => m.active)
    };
    if ((_d = (_c = currentListData === null || currentListData === void 0 ? void 0 : currentListData[index]) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length) onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedItem);
  };
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: listDataState && (0, _jsxRuntime.jsx)(_list.Components.Wrapper, (0, _extends2["default"])({
      className: className,
      noBorder: noBorder
    }, {
      children: listDataState === null || listDataState === void 0 ? void 0 : listDataState.map((item, index) => {
        var _a;
        return (0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
          children: [(item === null || item === void 0 ? void 0 : item.group) && (0, _jsxRuntime.jsx)(_list.Components.Item, (0, _extends2["default"])({
            staticItem: true
          }, {
            children: (0, _jsxRuntime.jsx)(_list.Components.Content, {
              children: (0, _jsxRuntime.jsx)("p", {
                children: item === null || item === void 0 ? void 0 : item.group
              })
            })
          })), (_a = item === null || item === void 0 ? void 0 : item.items) === null || _a === void 0 ? void 0 : _a.map((subList, subIndex) => (0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
            children: [(0, _jsxRuntime.jsxs)(_list.Components.Item, (0, _extends2["default"])({
              disabled: subList.disabled,
              className: active.group === index && active.list === subIndex || subList.active ? 'active' : '',
              active: active.group === index && active.list === subIndex || subList.active,
              indented: !!(item.group || subList.indented),
              onClick: () => onSelectedActive(index, subIndex)
            }, {
              children: [subList.graphic && (0, _jsxRuntime.jsx)(_list.Components.Graphics, {
                children: subList.graphic
              }, subIndex), subList.iconName && (0, _jsxRuntime.jsx)(_list.Components.Icon, {
                children: (0, _jsxRuntime.jsx)(_Icon["default"], {
                  name: subList.iconName
                })
              }), (0, _jsxRuntime.jsxs)(_list.Components.Content, (0, _extends2["default"])({
                active: active.group === index && active.list === subIndex || subList.active,
                disabled: subList.disabled
              }, {
                children: [(0, _jsxRuntime.jsx)("p", {
                  children: subList.value
                }, subIndex), subList.secondaryValue && (0, _jsxRuntime.jsx)("span", {
                  children: subList.secondaryValue
                })]
              })), subList.trailingIcon && (0, _jsxRuntime.jsx)(_list.Components.TrailingIcon, {
                children: (0, _jsxRuntime.jsx)(_Icon["default"], {
                  name: subList.trailingIcon
                })
              })]
            })), subList.seperator && (0, _jsxRuntime.jsx)("hr", {})]
          }, subIndex))]
        }, index);
      })
    }))
  });
};
var _default = exports["default"] = List;